// extracted by mini-css-extract-plugin
module.exports = {"baseBlock":"BaseBlock_baseBlock_k_U7m"};